import { useEffect, useState } from "react";
import { Card, Col, Container } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ApiService from "../../../services/api";
import { Link } from "react-router-dom";
import moment from "moment";

const ActivityListDashboard = () => {
  const [activitiy, setActivitiy] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchActivities = async () => {
    const activities = await ApiService.getLatestActivities();
    setActivitiy(activities);
    setLoading(false);
  };
  
  useEffect(() => {
    fetchActivities();
  }, []);

 const columns = [
     {
       name: "Data",
       selector: (row) => moment(row.date).format("DD-MM-YYYY HH:mm"),
       sortable: true,
       center: "true",
       width: "33%",
     },
     {
       name: "Utente",
       selector: (row) => row.user_data.username,
       center: "true",
       width: "33%",
     },
     {
       name: "Attivita",
       selector: (row) => row.description,
       center: "true",
       width: "34%",
     },
   ];

  if (Loading) {
    return;
  }

  return <>
      <div className="admin-card">
          <div className="admin-card-header">
              <div className="admin-card-icon admin-card-icon-news black-gradient">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-hourglass-split"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                </svg>
              </div>
              <p><small>Ultime attività</small></p>
          </div>
          <hr className="divider-dark mb-0" />
          <div className="admin-card-content">
              <DataTable columns={columns} data={activitiy} />
              <div className="mb-4 text-end">
                  <a href="/admin/activityList" className="admin-link admin-card-view-more site-link">
                      Visualizza tutte
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                      </svg>
                  </a>
              </div>
          </div>
      </div>
  </>
};
export default ActivityListDashboard;
